module.exports = "/_next/static/images/Ana_Paduret-58a76ba4a9c1a26975153ea876f8c20e.webp";